import onGetRelatedClients from './onGetRelatedClients';
import onGetClientAllocations from './onGetClientAllocations';
import onGetClientAllocationsStandard from './onGetClientAllocationsStandard';
import onGetClientAllocationsCrisis from './onGetClientAllocationsCrisis';
import onGetClientAllocation from './onGetClientAllocation';
import onGetOwnClientAllocation from './onGetOwnClientAllocation';
import onGetAllocationClientsByGroup from './onGetAllocationClientsByGroup';
import onGetGlobalUserClientAllocations from './onGetGlobalUserClientAllocations';
import onGetAllocationClientsByGroupGU from './onGetAllocationClientsByGroupGU';
import onGetOwnClientAllocationGU from './onGetOwnClientAllocationGU';
import onGetClientAllocationGU from './onGetClientAllocationGU';
import onAddClientAllocation from './onAddClientAllocation';
import onAddOwnClientAllocation from './onAddOwnClientAllocation';
import onAddOwnClientAllocationGU from './onAddOwnClientAllocationGU';
import onDeleteOwnClientAllocationGU from './onDeleteOwnClientAllocationGU';
import onValidateAvailability from './onValidateAvailability';
import onValidateDateRange from './onValidateDateRange';

export default {
  onGetRelatedClients,
  onGetClientAllocations,
  onGetClientAllocationsStandard,
  onGetClientAllocationsCrisis,
  onGetClientAllocation,
  onGetOwnClientAllocation,
  onGetAllocationClientsByGroup,
  onGetGlobalUserClientAllocations,
  onGetAllocationClientsByGroupGU,
  onGetOwnClientAllocationGU,
  onGetClientAllocationGU,
  onAddClientAllocation,
  onAddOwnClientAllocation,
  onAddOwnClientAllocationGU,
  onDeleteOwnClientAllocationGU,
  onValidateAvailability,
  onValidateDateRange,
};
